<style type="text/css">

        #preload {
              background-color: #FFC83D;
              bottom: 0px;
              left: 0px;
              position: fixed;
              right: 0px;
              top: 0px;
              z-index: 999999;
          }

        #preload .spinner {
          margin: 100px auto;
          width: 40px;
          height: 40px;
          position: relative;
          text-align: center;
          top: 30%;
          
          -webkit-animation: sk-rotate 2.0s infinite linear;
          animation: sk-rotate 2.0s infinite linear;
        }

        #preload .dot1, .dot2 {
          width: 60%;
          height: 60%;
          display: inline-block;
          position: absolute;
          top: 0;
          background-color: #FFFFFF;
          border-radius: 100%;
          
          -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
          animation: sk-bounce 2.0s infinite ease-in-out;
        }

        #preload .dot2 {
          top: auto;
          bottom: 0;
          -webkit-animation-delay: -1.0s;
          animation-delay: -1.0s;
        }

        @-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
        @keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

        @-webkit-keyframes sk-bounce {
          0%, 100% { -webkit-transform: scale(0.0) }
          50% { -webkit-transform: scale(1.0) }
        }

        @keyframes sk-bounce {
          0%, 100% { 
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
          } 50% { 
            transform: scale(1.0);
            -webkit-transform: scale(1.0);
          }
        }
      </style>

      <div id="preload" [hidden]="hidden">
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
      </div>


<navbar></navbar>
<router-outlet style="z-index: 10;"></router-outlet>
<appFooter style="z-index: -1;"></appFooter>

<div id="popUp" class="modal" [ngClass]="{'fadeIn': toPopUp}" [style.visibility]="toPopUp ? 'visible' : 'hidden'">
  <div class="modal-dialog" [style.visibility]="toPopUp ? 'visible' : 'hidden'">
    <div class="inner">
      <div class="modal-header"><a (click)="toPopUp = false" title="Close" class="close" style="cursor: pointer" data-dismiss="modal"></a>
        <h3 class="modal-title">ATTENTION</h3>
      </div>
      <div class="modal-body">
        <div class="pop-up"><span>{{popUpMsg}}</span></div>
      </div>
      <div class="modal-footer">
       <!-- <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
       <button type="button" class="btn btn-default" (click)="close()" >Cancel</button> -->
      </div>
    </div>
  </div>
</div>

